<template>
  <div>
       <!--================ Hero sm Banner start =================-->      
    <section class="hero-banner mb-30px">
      <div class="container">
        <div class="row" v-if="!valid">
          <div class="col-lg-8">
            <div class="hero-banner__content">
              <h1>One step from your free trial</h1>
              <p>
                  Retainerdesk helps you to understand your customer churn, and actively reducing it.<br>
              </p>
                <div class="form-group" style="min-width:300px; max-width:500px;">
                  <input  v-model="email" class="form-control" name="email" placeholder="Email">
                  <div style="height:10px;"></div>
                  <input  v-model="company" class="form-control" name="company" placeholder="Company name">
                </div>
                <div style="color:white; font-size:12px; margin-bottom:10px;">14 day free trial - cancel anytime - No credit card required</div>
              <button type="button" class="button bg" @click="sendMail()">Try it free now</button>
            </div>
          </div>
          <div class="col-lg-4" style="color:white;">
 
            <h2 style="color:white; margin-top:20px;">You'll know things like:</h2>
            <ul>
                <li><span class="ti-check" /> Who is considering canceling</li>
                <li><span class="ti-check" /> Who has canceled </li>
                <li><span class="ti-check" /> Why they're canceled</li>
                <li><span class="ti-check" /> What offers are keeping people around</li>
            </ul>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-lg-12">
            <div class="hero-banner__content">
              <h1>We will be in touch!</h1>
              <p>
                  Our churn experts will be in touch shortly to help you set up your account.<br>
              </p>
                <div style="color:white; font-size:12px; margin-bottom:10px;">
                    <b>Any questions? Please feel free to call us or email:</b><br>
                    Phone: +46 8 551 092 80<br>
                    Email: taieb@retainerdesk.com
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  <!--================ Offer section start =================-->    
      <section class="section-padding--small bg-magnolia" style="display:none;">
      <div class="container">
        <div class="row align-items-center pt-xl-3 pb-xl-5">
          <div class="col-lg-6">
            <div class="solution__img text-center text-lg-left mb-4 mb-lg-0">
              <img class="img-fluid" src="../assets/retention_flow_retainerdesk.png" alt="">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="solution__content">
              <h2>Intelligent Retention Flow</h2>
              <p>The Retention Flow gives the users motivators for them to keep using your service.
                  A motivator could contain:
              </p>
            <ul>
                <li><span class="ti-check" /> Discount offers that are tailored for the user</li>
                <li><span class="ti-check" /> Information about new features </li>
                <li><span class="ti-check" /> Priority support number access</li>
                <li><span class="ti-check" /> Offers & interface shown from machine learning</li>
            </ul>
            </div>
          </div>
        </div>
      </div>
    </section>  
  <section class="section-margin" style="display:none;">
    <div class="container">
      <div class="text-center">
        <h2 class="section-intro__title">Powerful churn analytics</h2>
            <div class="about__img">
              <img class="img-fluid" src="../assets/retainerdesk_analytics.png" alt="">
            </div> 
        </div>

    </div>
  </section>
    <section class="clients_logo_area section-padding" style="display:none;">
      <div class="container">
        <div class="section-intro pb-5 text-center">
          <h2 class="section-intro__title">Trusted by top companies:</h2>
        </div>
        <div class="clients_slider owl-carousel">
          <div class="item">
            <img src="https://content.web-repository.com/s/10268962316471152/uploads/Logga/Hemsida_online-7839389.png" style="width:180px; height:auto; padding-top:20px;" alt="">
          </div>
          <div class="item">
            <img src="https://lembly.com/lembly.png" style="width:200px; height:auto;" alt="">
          </div>
          <div class="item">
            <img src="https://offerta.se/api/files/6bee0764-0310-4600-bd21-61e72a56970a/continental-systems-ab.jpg" style="padding-top:20px;" alt="">
          </div>
          <div class="item">
            <img src="https://lembly.com/tlo.png" style="width:180px; height:auto;" alt="">
          </div>
        </div>
      </div>
    </section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: '',
            company: '',
            valid: false,
        }
    },
    created() {
      window.location.href = 'https://app.retainerdesk.com/#/register';
    },
    methods: {
        sendMail() {

			const obj = {
				from: this.email,
				to: 'taieb@retainerdesk.com'
			}

			if(this.email.length < 3) {
				alert("Your email need to be valid");
				return;
            }
            if(this.company.length < 2) {
				alert("You need ti fill in company name");
				return;
            }

		    this.$store.dispatch('SEND_MAIL', obj);
            this.valid = true;
            gtag_report_conversion()
		}
    }

}
</script>

<style>

</style>